import Transaction from "../domain/Transaction";
import RawWsService from "./RawWsService";
import UserSessionService from "./UserSessionService";
import WsService from "./WsService";
import TransactionRequest from "../domain/TransactionRequest";
import TransactionResponse from "../domain/TransactionResponse";

const ENDPOINT_BASE = "/admin/transaction";

export default class TransactionService {

    static retrieveTransactionsByRegistrationId(registrationId) {

        let endpoint = ENDPOINT_BASE + "?registration-id=" + registrationId + "&transaction-id=&remittance-brand-reference-number=&beneficiary-first-name=&beneficiary-last-name=";

        let headers = {"X-sort-by": "transactionDate", "X-sort-order": "DESC", "X-Page-Size":"100"};

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let responseArr = [];
                response.body.forEach(transaction => {
                    responseArr.push(new Transaction(transaction))
                });
                return responseArr;
            },
            response => {
                return response;
            }
        )

    }

    static retrieveTransactionByTransactionId(transactionId) {

        let endpoint = "/transactions/transaction/" + transactionId;

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new Transaction(response)
            },
            response => {
                return response;
            }
        )

    }

    static createTransaction(transactionRequest) {

        let endpoint = "/transactions/transaction";
        let jsonObj = TransactionRequest.toJson(transactionRequest);

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        return RawWsService.postWithHeaders(endpoint, jsonObj, 201, headers).then(
            response => {
                return new TransactionResponse(response.body);
            },
            response => {
                return response;
            });
    }

}